<div class="custom-icon" [id]="'icon'+componentId" #icon>
</div>
